import Vue from 'vue';

import { format, formatDistanceToNow } from 'date-fns';

import './preferences';

Vue.filter('relativeDate', value => {
  const date = new Date(value);
  return `${formatDistanceToNow(date)} ago`;
});

Vue.filter('date', value => {
  const date = new Date(value);
  return format(date, 'do MMM y, HH:mm:ss');
});

const sizeUnits = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
Vue.filter('humanFileSize', value => {
  value = parseInt(value, 10);
  let i = 0;
  while (Math.abs(value) >= 1000 && i < sizeUnits.length - 1) {
    value /= 1000;
    i++;
  }

  return `${+value.toFixed(2)} ${sizeUnits[i]}`;
});
